import { useState } from "react";

import { CopyOutlined, RollbackOutlined } from "@ant-design/icons";

import { Button } from "../Button";
import { Tooltip } from "../Tooltip";

import * as theme from "./AIPromptResponseButtonPanel.css";

const COPY_TOOLTIP_CLOSE_DELAY = 500;
interface ButtonPanelProps {
    onRevertClick?: () => void;
    copyTooltipLabel?: string;
    copiedTooltipLabel?: string;
    revertTooltipLabel: string;
    onCopyClick?: () => void;
    onInsertClick?: () => void;
    insertLabel?: string;
}
export function AIPromptResponseButtonPanel({
    onRevertClick,
    revertTooltipLabel,
    onCopyClick,
    copyTooltipLabel,
    copiedTooltipLabel,
    onInsertClick,
    insertLabel,
}: ButtonPanelProps) {
    const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);
    const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);

    const handleCopyClick = () => {
        if (!onCopyClick) {
            return;
        }
        onCopyClick();
        setShowCopiedTooltip(true);
        setTimeout(() => {
            setCopyTooltipOpen(false);
            setShowCopiedTooltip(false);
        }, COPY_TOOLTIP_CLOSE_DELAY);
    };

    const showInsertButton = Boolean(onInsertClick && insertLabel);
    const showCopyButton = Boolean(
        onCopyClick && copyTooltipLabel && copiedTooltipLabel
    );
    const showRevertButton = Boolean(onRevertClick && revertTooltipLabel);

    return (
        <div className={theme.root}>
            {showInsertButton && (
                <Button
                    onClick={onInsertClick}
                    variant="primary"
                    size="small"
                    data-pendo="ai-description-insert"
                >
                    {insertLabel}
                </Button>
            )}
            {showCopyButton && (
                <Tooltip
                    title={
                        showCopiedTooltip
                            ? copiedTooltipLabel
                            : copyTooltipLabel
                    }
                    open={copyTooltipOpen}
                >
                    <Button
                        onMouseEnter={() => setCopyTooltipOpen(true)}
                        onMouseLeave={() => setCopyTooltipOpen(false)}
                        onClick={handleCopyClick}
                        icon={<CopyOutlined />}
                        variant="text"
                        size="nosize"
                    />
                </Tooltip>
            )}
            {showRevertButton && (
                <Tooltip title={revertTooltipLabel}>
                    <Button
                        onClick={onRevertClick}
                        icon={<RollbackOutlined />}
                        variant="text"
                        size="nosize"
                    />
                </Tooltip>
            )}
        </div>
    );
}
